import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-jdai-landing',
  styleUrls: [],
  template: `
    <div class="prelogin-jdai-imgcontainer">
    </div>`
})
export class JdaiLandingComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle(environment.jdaiPageTitle);
  }

}